<script>
export default {

    name: 'custom-button',

    props: {
        classes: String,
        disabled: Boolean,
        text: String,
        iconBeforeText: String,
        iconAfterText: String,
        buttonType:{
            type:String,
            default:'button',
        }
    },

    computed:{
        internalClasses(){
            const classList = this.classes ? this.classes.split(' ') : []
            if (!this.iconAfterText) {
                classList.push('no-icon')
            }
            return classList
        }
    },

    methods: {
        buttonClick(){
            this.$emit('buttonClick')
        }
    },
}
</script>

<template lang="html">
    <button @click="buttonClick" class="engage-button" :disabled="disabled" :class="internalClasses">
        <i :class="iconBeforeText"></i>
        {{ text }}
        <i :class="iconAfterText"></i>
    </button>
</template>



// WEBPACK FOOTER //
// src/components/forms/elements/button.vue